/* eslint-disable no-unused-vars */

// set up the default state for the module
const initialState = {
  show: false,
  settings: {
    notificationType: 'success',
    title: '',
    message: '',
    action: '',
    actionLabel: '',
    showContactInfo: true,
    tinted: false,
  },
};

const actions = {
  openNotification: {
    root: true,
    handler({ commit, state }, settings) {
      commit('updateMessage', settings);
      commit('openNotification');
    },
  },
  closeNotification: {
    root: true,
    handler({ commit, state }) {
      commit('resetMessage');
      commit('closeNotification');
    },
  },
};

const mutations = {
  openNotification(state) {
    state.show = true;
  },
  closeNotification(state) {
    state.show = false;
  },
  updateMessage(state, settings) {
    if (settings) {
      state.settings.notificationType = settings.notificationType || 'success';
      state.settings.title = settings.title;
      state.settings.message = settings.message;
      state.settings.action = settings.action;
      state.settings.actionLabel = settings.actionLabel;
      state.settings.showContactInfo = settings.showContactInfo;
      state.settings.tinted = settings.tinted || false;
    } else {
      state.settings = {
        notificationType: 'success',
        title: '',
        message: '',
        action: '',
        actionLabel: '',
        showContactInfo: true,
        tinted: false,
      };
    }
  },
  resetMessage(state, payload) {
    state.settings = {
      notificationType: 'success',
      title: '',
      message: '',
      action: '',
      actionLabel: '',
      showContactInfo: true,
      tinted: false,
    };
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
